import { ACHIEVEMENT_TYPES } from "../../constants/gamification/achievementTypes";

// Define the structure of the state
interface AchievementState {
  achievements: any;
  tutorialResult: any;
}

// Define the type for the action
interface AchievementAction {
  type: string;
  payload: any;
}

// Initial state
const initialState: AchievementState = {
  achievements: null,
  tutorialResult: null,
};

const achievementReducer = (
  state = initialState,
  action: AchievementAction
): AchievementState => {
  switch (action.type) {
    case ACHIEVEMENT_TYPES.GET_USER_ACHIEVEMENTS:
      return {
        ...state,
        achievements: action.payload,
      };
    case ACHIEVEMENT_TYPES.COMPLETE_TUTORIAL:
      return {
        ...state,
        tutorialResult: action.payload,
      };
    default:
      return state;
  }
};

export default achievementReducer;